<input
    type="text"
    class="form-control"
    placement="auto"
    value="{{ dateTime | date: 'yy-M-d HH:mm' }}"
    #popoverRef="bs-popover"
    [popover]="popTemplate"
    [outsideClick]="false"
/>

<ng-template #popTemplate class="custom-popover-position">
    <bs-datepicker-inline
        [(bsValue)]="date"
        [minDate]="minDate"
        [bsConfig]="datePickerConfig"
        (bsValueChange)="dateSelectionDone($event)"
    >
    </bs-datepicker-inline>
    <timepicker
        [(ngModel)]="time"
        [showMeridian]="false"
        [hourStep]="1"
        [minuteStep]="5"
        (ngModelChange)="timeSelectionDone($event)"
    >
    </timepicker>

    <div class="button-wrapper">
        <button type="button" class="btn btn-action btn-close" (click)="onClose()">
            {{ "close" | translate }}
        </button>
    </div>
</ng-template>
